module.exports = __webpack_public_path__ + "static/media/Sableye_gaussian2.d4a05a5a.png";